<template>
	<div class="xinxi_solution_main">
		<div class="xinxi_solution_bg">
			<div class="main_mobile">
				<ul>
					<li class="one on">
						<div class="left1"></div>
						<div class="left_top">
							<img
								src="../assets/main/reporticon.png"
								alt="工业"
							/>
							<i>信息专报</i>
						</div>
						<div class="right">
							<dl style="top:15%;">
								<a
									v-for="(item, index) in gjyj"
									:key="index"
									:title="item.title"
									:docid="item.docid"
									:href="
										'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
											item.docid +
											'&leafid=' +
											item.leafid
									"
									target="_blank"
								>
									<span>{{ item.title }}</span>
									<span>{{
										item.deliveddate | subData
									}}</span>
								</a>
							</dl>
							<a
								class="report_click_more"
								href="#/column?id=82&name=报告专题&uid=410903"
								target="_blank"
								>查看更多</a
							>
						</div>
					</li>
					<li class="one">
						<div class="left2"></div>
						<div class="left_top">
							<img
								src="../assets/main/reporticon.png"
								alt="工业"
							/>
							<i>热点研究</i>
						</div>
						<div class="right">
							<dl style="top:15%;">
								<a
									v-for="(item, index) in gnyj"
									:key="index"
									:title="item.title"
									:docid="item.docid"
									:href="
										'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
											item.docid +
											'&leafid=' +
											item.leafid
									"
									target="_blank"
								>
									<span>{{ item.title }}</span>
									<span>{{
										item.deliveddate | subData
									}}</span>
								</a>
							</dl>
							<a
								class="report_click_more"
								href="#/column?id=81&name=报告专题&uid=410902"
								target="_blank"
								>查看更多</a
							>
						</div>
					</li>
					<li class="one">
						<div class="left3"></div>
						<div class="left_top">
							<img
								src="../assets/main/reporticon.png"
								alt="工业"
							/>
							<i>国际视角</i>
						</div>
						<div class="right">
							<dl style="top:15%;">
								<a
									v-for="(item, index) in zzzk"
									:key="index"
									:title="item.title"
									:docid="item.docid"
									:href="
										'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
											item.docid +
											'&leafid=' +
											item.leafid
									"
									target="_blank"
								>
									<span>{{ item.title }}</span>
									<span>{{
										item.deliveddate | subData
									}}</span>
								</a>
							</dl>
							<a
								class="report_click_more"
								href="#/column?id=80&name=报告专题&uid=410901"
								target="_blank"
								>查看更多</a
							>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import $ from 'jquery';

export default {
	// 手风琴效果
	props: {},
	components: {},
	data() {
		return {
			gjyj: {}, //国际研究
			gnyj: {}, //国内研究
			zzzk: {}, //自主周刊
		};
	},
	computed: {},
	created() {},
	mounted() {
		this.actions();
		this.sfetchData3('410903', 1); //获取国际研究数据
		this.sfetchData2('410902', 1); //获取国内研究数据
		this.sfetchData1('410901', 1); //获取自主周刊数据
	},
	methods: {
		//获取国际研究数据
		sfetchData1(_uid, i) {
			let param = { uid: _uid, pagesize: 5, curpage: 1 };

			// param.uid = '7407';//等有数据了去掉这里

			api.getDocList(param).then((res) => {
				// $('.article_l_tab1').removeClass('active');
				// $('.article_l_tab2').removeClass('active');
				// $('.article_l_tab' + i).addClass('active');
				//console.log(res,'res_test')
				this.gjyj = res.data;
			});
		},
		//获取国内研究数据
		sfetchData2(_uid, i) {
			let param = { uid: _uid, pagesize: 5, curpage: 1 };

			// param.uid = '7407';//等有数据了去掉这里

			api.getDocList(param).then((res) => {
				// $('.article_l_tab1').removeClass('active');
				// $('.article_l_tab2').removeClass('active');
				// $('.article_l_tab' + i).addClass('active');

				this.gnyj = res.data;
			});
		},
		//获取自主周刊数据
		sfetchData3(_uid, i) {
			let param = { uid: _uid, pagesize: 5, curpage: 1 };

			// param.uid = '7407';//等有数据了去掉这里

			api.getDocList(param).then((res) => {
				// $('.article_l_tab1').removeClass('active');
				// $('.article_l_tab2').removeClass('active');
				// $('.article_l_tab' + i).addClass('active');

				this.zzzk = res.data;
			});
		},
		// 手风琴效果
		actions() {
			$('.xinxi_solution_main ul li:eq(0)').addClass('on');
			$('.xinxi_solution_main ul li:eq(1)').addClass('b2');
			$('.xinxi_solution_main ul li:eq(2)').addClass('b3');
			$('.xinxi_solution_main ul li:eq(3)').addClass('b4');
			$('.xinxi_solution_main ul li:eq(4)').addClass('b5');
			$('.xinxi_solution_main ul li:eq(5)').addClass('b6');
			$('.xinxi_solution_main ul li:gt(3)').hide();
			//当三级分类大于7个的是，成两排显示
			$('.xinxi_solution_main ul li').each(function() {
				var len = $(this).find('.right dl a').length;
				if (len > 6) {
					$(this)
						.find('.right dl a')
						.addClass('yichu');
				}
			});

			//解决方案效果
			$('.xinxi_solution_main ul li').each(function() {
				var left_h = $(this)
					.find('.left_top')
					.height();
				$(this)
					.find('.left_top')
					.css({
						top: '50%',
						'margin-top': -left_h / 1.4,
					});

				var dl_h = $(this)
					.find('.right dl')
					.height();
				$(this)
					.find('.right dl')
					.css({
						'margin-top': -dl_h / 1.8,
					});
			});
			$('.xinxi_solution_main ul li').mouseover(function() {
				$(this)
					.addClass('on')
					.siblings()
					.removeClass('on');
			});
			$('.xinxi_solution_main_mobile ul li:first-child').addClass('on');

			$('.xinxi_solution_main_mobile ul li').click(function() {
				$(this)
					.addClass('on')
					.siblings()
					.removeClass('on');
			});

			$('.solu-category .solu-description').each(function() {
				var maxwidth = 60;
				if ($(this).text().length > maxwidth) {
					$(this).text(
						$(this)
							.text()
							.substring(0, maxwidth)
					);
					$(this).html($(this).html() + '...');
				}
			});
		},
	},
	filters: {
		subData: function(value) {
			return value.substring(0, 10);
		},
	},
};
</script>
<style scoped lang="less">
ul li {
	list-style-type: none;
}
a {
	text-decoration: none;
}
img {
	border: none;
}
em,
i {
	font-style: normal;
}
.xinxi_solution_bg {
	background-size: 100% 400px;
	max-width: 1920px;
	margin: 0 auto;
	background-color: #f7f7f7;
}
.xinxi_solution_main ul {
	overflow: hidden;
	height: 366px;
}
.xinxi_solution_main .main_mobile {
	max-width: 1200px;
	min-width: 1200px;
}
.xinxi_solution_main ul li {
	background: #fff;
	height: 400px;
	float: left;
	width: 183px;
	position: relative;
	overflow: hidden;
	transition: all 0.5s;
}
.xinxi_solution_main ul li:nth-child(2) {
	background: #fff;
}
.xinxi_solution_main ul li:nth-child(3) {
	background: #fff;
}
.xinxi_solution_main ul li:nth-child(4) {
	background: #fff;
}
.xinxi_solution_main ul li:nth-child(5) {
	background: #fff;
}
.xinxi_solution_main ul li:nth-child(6) {
	background: #fff;
}
.xinxi_solution_main ul li .left_top {
	position: absolute;
	left: 0;
	width: 143px;
	padding: 0 20px;
	text-align: center;
}
.xinxi_solution_main ul li .left_top img {
	width: 60px;
	display: block;
	margin: 0 auto 14px;
}
.xinxi_solution_main ul li i {
	font-size: 22px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	width: 100%;
	text-align: center;
}
.xinxi_solution_main .left_top {
	font-size: 30px;
	color: #fff;
}
.xinxi_solution_main ul li .left1 {
	float: left;
	width: 183px;
	background: url('../assets/main/reportbg1.png') no-repeat center;
	background-size: cover;
	height: 366px;
}
.xinxi_solution_main ul li .left2 {
	float: left;
	width: 183px;
	background: url('../assets/main/reportbg2.png') no-repeat center;
	background-size: cover;
	height: 366px;
}
.xinxi_solution_main ul li .left3 {
	float: left;
	width: 183px;
	background: url('../assets/main/reportbg3.png') no-repeat center;
	background-size: cover;
	height: 366px;
}
.xinxi_solution_main ul li .right {
	float: left;
	width: 650px;
	position: relative;
	height: 366px;
}
.xinxi_solution_main .right dl {
	position: absolute;
	top: 50%;
	left: 30px;
}
.xinxi_solution_main .right dd {
	color: #fff;
	font-size: 26px;
	border-radius: 5px;
	width: 280px;
	height: 75px;
	margin-bottom: 45px;
	background: #000;
	opacity: 0.5;
}
.xinxi_solution_main .right dl a {
	width: 568px;
	display: block;
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #666666;
	margin-bottom: 28px;
	overflow: hidden;
}
.xinxi_solution_main .right dl a span:first-child {
	width: 402px;
	display: inline-block;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	float: left;
}
.xinxi_solution_main .right dl a span:last-child {
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #999999;
	float: right;
}
.report_click_more {
	width: 76px;
	height: 31px;
	line-height: 31px;
	background: #4eac41;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #fafafa;
	text-align: center;
	cursor: pointer;
	position: absolute;
	bottom: 40px;
	right: 49px;
}
// .xinxi_solution_main .right dl a.yichu { float: left; margin-right: 20px; }
.xinxi_solution_main ul li.on {
	width: 833px;
}
// .xinxi_solution_main ul li.two { background: url('../../plugins/shoufengqin/images/pic2.png') no-repeat; }
// .xinxi_solution_main ul li.thr { background: url('../../plugins/shoufengqin/images/pic3.png') no-repeat; }
// .xinxi_solution_main ul li.four { background: url('../../plugins/shoufengqin/images/pic4.png') no-repeat; }
// .xinxi_solution_main ul li.five { background: url('../../plugins/shoufengqin/images/pic5.png') no-repeat; }
// .xinxi_solution_main ul li.six { background: url('../../plugins/shoufengqin/images/pic6.png') no-repeat; }
</style>



// WEBPACK FOOTER //
// src/components/shoufengqin.vue